export const searchFormOption = function () {
    return [
      {
        prop: 'keyword',
        label: '关键字',
        type: 'input',
        placeholder: '请输入车架号/车牌号',
        width: '20%'
      },
      {
          prop: 'orgNo',
          label: '出单机构',
          type: 'cascader',
          placeholder: '请选择内容',
          propConfig: {
              children: 'children',
              label: 'orgName',
              value: 'id',
              checkStrictly: true,
              emitPath: false,
          },
          options: this.$store.state.app.orgList,
          width: '20%'
      },
      {
          prop: 'saleNo',
          label: '业务员',
          type: 'select',
          width: '20%',
          options: this.$store.state.app.salesmanList
      },
      {
          prop: 'status',
          label: '状态',
          type: 'select',
          width: '20%',
          options: this.$emun.status
      },
    ]
}

export const cashFormOption = function() {
    return [
      {
        prop: 'contractFee',
        label: '标准统筹费(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'cusFee',
        label: '应交统筹费(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'customerFee',
        label: '客户统筹费(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'netFee',
        label: '净费(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'inType',
        label: '收款方式',
        type: 'checkbox',
        options: this.$emun.patModeOption
      },
    ]
  }

export default {}